import { Component } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AuthService } from 'src/app/auth.service';
import { environment } from 'src/environments/environment';
import { MySpaceService } from '../my-space.service';

@Component({
  selector: 'app-my-space-config',
  templateUrl: './my-space-config.component.html',
  standalone: false,
})
export class MySpaceConfigComponent {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<MySpaceConfigComponent>,
    private authService: AuthService,
    private mySpaceService: MySpaceService
  ) {}

  dismiss() {
    this.bottomSheetRef.dismiss();
  }

  isAdmin() {
    return this.authService.isAdmin();
  }

  isWriter() {
    return this.authService.isWriter();
  }

  getMySpaceCustomizerTab() {
    return '/myspace/personalize-app/' + this.mySpaceService.getSavedCustomizeAppTab();
  }

  get enableAppCustomization() {
    return environment.enableAppCustomization;
  }
}
